import { Alert, Button, Group, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Component, type ReactNode } from 'react';

/**
 * Błąd renderu strony — komunikat z przyciskiem „Odśwież” zamiast białego ekranu.
 * `resetKey` (np. adres strony) — zmiana czyści błąd, więc przejście w menu działa dalej.
 */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null; key?: string }> {
  override state: { error: Error | null; key?: string } = { error: null, key: this.props.resetKey };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  static getDerivedStateFromProps(props: { resetKey?: string }, state: { error: Error | null; key?: string }) {
    return props.resetKey !== state.key ? { error: null, key: props.resetKey } : null;
  }

  override componentDidCatch(error: Error) {
    console.error('Błąd widoku', error);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <Alert color="red" variant="light" icon={<IconAlertTriangle />} title="Nie udało się wyświetlić tej strony" m="md">
        <Text size="sm" mb="sm">
          Odśwież stronę. Jeśli błąd się powtarza, zgłoś go z opisem, co było kliknięte.
        </Text>
        <Group>
          <Button size="xs" onClick={() => window.location.reload()}>
            Odśwież
          </Button>
        </Group>
      </Alert>
    );
  }
}
